<template>
  <div class="product" @click="$emit('onClick')">
    <el-card>
      <ImageContainer :image-src="dataSource.imageUrl" />
      <div class="product__content-container">
        <p class="product__title">{{ dataSource.title }}</p>
        <p class="product__subTitle">{{ dataSource.subtitle }}</p>
      </div>
      <div class="product__detail">
        <div>
          <p> 庫存： {{ dataSource.stockNum || 0 }}</p>
          <p> 購物回潤金： {{ dataSource.returnMoney || 0 }}</p>
        </div>
        <div>
          <p v-if="dataSource.originalPrice" class="product__originalPrice">${{ dataSource.originalPrice | currency }}</p>
          <p class="product__price">${{ dataSource.price | currency }}</p>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import ImageContainer from '@/components/ImageContainer'

export default {
  components: {
    ImageContainer
  },
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style lang="scss">
.product {
  cursor: pointer;
  margin-bottom: 20px;
  position: relative;
  &:before {
    position:absolute;
    content: '';
    width: 6px;
    height: 100%;
    background-color: $mainPurple;
    left: -6px;
    top: 0;
    display: none;
  }
  &:hover:before {
    display: block;
  }
  .image-container {
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
  &__content-container {
    padding: 14px;
    text-align: left;
    height: 150px;
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: $mainPurple;
    overflow : hidden;
    text-overflow : ellipsis;
    //white-space : nowrap;
  }
  &__subTitle {
    margin: 2px 0;

    @include minWidth768 {
      font-size: 18px;
    }
  }

  &__originalPrice {
    text-decoration:line-through;
    margin-right: 12px;
    font-size: 20px;
    color:#929292;
    @include minWidth768 {
      font-size: 24px;
    }
  }
  &__price {
    font-size: 24px;
    font-weight: 600;
    color: #FA3150;
    @include minWidth768 {
      font-size: 32px;
    }
  }
  &__row {
    display: flex;
    justify-content: space-between;
    margin: 0;
  }
  .el-card__body {
    padding: 0;
  }
  &__detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fafafa;
    padding: 15px 20px;
    margin: 20px 0;
  }
  &__priceDetail {
    padding: 20px 10px 0 0;
    p {
      margin: 0;
    }
  }
  &__stock {
    font-size: 0.8rem;
  }
}
</style>
